import api from './api';
import { Abastecimento, ApiResponse } from '../types';

export const abastecimentoService = {
  listar: async (): Promise<Abastecimento[]> => {
    const response = await api.get<Abastecimento[]>('/abastecimentos');
    return response.data;
  },

  buscarPorId: async (id: number): Promise<Abastecimento> => {
    const response = await api.get<Abastecimento>(`/abastecimentos/${id}`);
    return response.data;
  },

  registrar: async (abastecimento: Abastecimento): Promise<ApiResponse<Abastecimento>> => {
    const response = await api.post<ApiResponse<Abastecimento>>('/abastecimentos', abastecimento);
    return response.data;
  },

  registrarPorSolicitacao: async (solicitacaoId: number, abastecimento: Abastecimento): Promise<ApiResponse<Abastecimento>> => {
    const response = await api.post<ApiResponse<Abastecimento>>(
      `/abastecimentos/por-solicitacao/${solicitacaoId}`,
      abastecimento
    );
    return response.data;
  },

  listarPorVeiculo: async (veiculoId: number): Promise<Abastecimento[]> => {
    const response = await api.get<Abastecimento[]>(`/abastecimentos/veiculo/${veiculoId}`);
    return response.data;
  },

  listarPorMotorista: async (motoristaId: number): Promise<Abastecimento[]> => {
    const response = await api.get<Abastecimento[]>(`/abastecimentos/motorista/${motoristaId}`);
    return response.data;
  },

  gerarGuiaPdf: async (id: number): Promise<Blob> => {
    const response = await api.get(`/abastecimentos/${id}/guia-pdf`, {
      responseType: 'blob',
    });
    return response.data;
  },
};
